import React from 'react'
import { readStoredJson, writeStoredJson } from '../../lib/safeStorage'

// Grup menu mana yang sedang dilipat, diingat per peran di peramban ini.
// Yang disimpan adalah kunci grup yang DILIPAT (bukan yang terbuka), jadi grup
// baru yang kelak ditambahkan ke menu otomatis tampil terbuka.
const storageKey = (role) => `gladhy_nav_closed:${role}`

function load(role) {
  const saved = readStoredJson(storageKey(role), [])
  return Array.isArray(saved) ? saved.filter((k) => typeof k === 'string') : []
}

export function useCollapsedGroups(role) {
  const [closed, setClosed] = React.useState(() => load(role))

  // Peran bisa berganti di tab yang sama (keluar lalu masuk sebagai orang lain).
  React.useEffect(() => { setClosed(load(role)) }, [role])

  const update = React.useCallback((fn) => {
    setClosed((prev) => {
      const next = fn(prev)
      writeStoredJson(storageKey(role), next)
      return next
    })
  }, [role])

  const isClosed = React.useCallback((key) => closed.includes(key), [closed])
  const toggle = React.useCallback(
    (key) => update((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key])),
    [update],
  )
  const open = React.useCallback(
    (key) => update((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : prev)),
    [update],
  )

  return { isClosed, toggle, open }
}
